import axios from "./requestWrapper";

const apiUrl = process.env.VUE_APP_API_URL;

const shippingService = {
  handleResponse(response) {
    return new Promise((res, rej) => {
      if (response.data.error) {
        rej(response.data.error);
      } else {
        res(response.data);
      }
    });
  },

  getCarriers() {
    return axios.get(`${apiUrl}/shipping`).then(shippingService.handleResponse);
  }
};

export default shippingService;
